export default __webpack_public_path__ + "static/media/simon.753e9bb3.png";